<div class="fpx-form-control">
    <fpx-label *ngIf="label" [control]="formControl" [label]="label"></fpx-label>
    <div class="fpx-field-content">
        <input matInput [maxlength]="maxLength" (blur)="trimText()" [formControl]="formControl" [ngClass]="{'input-available': formControl.value}" />
        <mat-placeholder *ngIf="placeholder" class="placeholder">{{ placeholder }}</mat-placeholder>
    </div>
    <mat-hint class="hint" *ngIf="hint" [innerHtml]="hint"></mat-hint>
    <mat-error *ngIf="formControl && formControl.invalid && formControl.touched">
        {{ errorCode }}
    </mat-error>
</div>